/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export class PriceFormatOptions {
    /**
     * @param {?} options
     */
    constructor(options) {
        this.defaults = {
            minValue: '',
            maxValue: '',
            prefix: 'R$ ',
            suffix: '',
            centsSeparator: '.',
            thousandsSeparator: ',',
            limit: false,
            centsLimit: 2,
            clearPrefix: true,
            clearSuffix: true,
            allowNegative: false,
            insertPlusSign: false,
            cssclass: '',
            placeholder: ''
        };
        this.current = {};
        this.options = {};
        this.current = Object.assign(this.defaults, {});
        this.updateOptions(options);
    }
    /**
     * @param {?} options
     * @return {?}
     */
    updateOptions(options) {
        this.options = Object.assign(this.defaults, options);
        if (isNaN(this.options['centsLimit']) || this.options['centsLimit'] < 0) {
            this.options['centsLimit'] = 2;
        }
        this.current = Object.assign(this.options, {});
    }
    /**
     * @return {?}
     */
    getOptions() {
        return this.options;
    }
}
function PriceFormatOptions_tsickle_Closure_declarations() {
    /** @type {?} */
    PriceFormatOptions.prototype.defaults;
    /** @type {?} */
    PriceFormatOptions.prototype.current;
    /** @type {?} */
    PriceFormatOptions.prototype.options;
}
/**
 * @record
 */
export function PriceFormatOptionsModel() { }
function PriceFormatOptionsModel_tsickle_Closure_declarations() {
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.minValue;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.maxValue;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.prefix;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.suffix;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.centsSeparator;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.thousandsSeparator;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.limit;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.centsLimit;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.clearPrefix;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.clearSuffix;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.allowNegative;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.insertPlusSign;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.cssclass;
    /** @type {?|undefined} */
    PriceFormatOptionsModel.prototype.placeholder;
}
;
